import { useMediaQuery } from 'react-responsive'

export const Desktop = ({ children }: any) => {
  const isDesktop = useMediaQuery({ minWidth: 1440 })

  return isDesktop ? children : null
}
export const Tablet = ({ children }: any) => {
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1440 })

  return isTablet ? children : null
}
export const Mobile = ({ children }: any) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })

  return isMobile ? children : null
}
